/**
 * Copyright 2025 SweetCode. All rights reserved.
 *
 * Source: https://www.outbrain.com/help/advertisers/dynamic-values/
 *
 * All event listeners
 * */

// Pixel load event listener
jQuery(document).on("pmw:load-pixels", () => {

	if (pmwDataLayer?.pixels?.outbrain?.advertiser_id && !pmwDataLayer?.pixels?.outbrain?.loaded) {
		if (pmw.consent.canPixelBeFired("marketing", "Outbrain")) pmw.loadOutbrainPixel()
	}
})

// view search event
jQuery(document).on("pmw:pixel:search", (event, payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "outbrain")) return
		if(pmw.canNotFireOutbrainEvent()) return

		const outbrainData = payload.pixels?.outbrain;
		if (!outbrainData) return;

		obApi("track", outbrainData.event_name)
		pmw.console.log("Outbrain: search event sent")

	} catch (e) {
		console.error(e)
	}
})

// ViewContent event
jQuery(document).on("pmw:pixel:view-item", (event, payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "outbrain")) return
		if(pmw.canNotFireOutbrainEvent()) return

		const outbrainData = payload.pixels?.outbrain;
		if (!outbrainData) return;

		obApi("track", outbrainData.event_name)
		pmw.console.log("Outbrain: view_content event sent")

	} catch (e) {
		console.error(e)
	}
})

// AddToCart event
jQuery(document).on("pmw:pixel:add-to-cart", (event, payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "outbrain")) return
		if(pmw.canNotFireOutbrainEvent()) return

		const outbrainData = payload.pixels?.outbrain;
		if (!outbrainData) return;

		obApi("track", outbrainData.event_name)
		pmw.console.log("Outbrain: add_to_cart event sent")

	} catch (e) {
		console.error(e)
	}
})

// begin_checkout event
jQuery(document).on("pmw:pixel:begin-checkout", (event, payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "outbrain")) return
		if(pmw.canNotFireOutbrainEvent()) return

		const outbrainData = payload.pixels?.outbrain;
		if (!outbrainData) return;

		obApi("track", outbrainData.event_name)
		pmw.console.log("Outbrain: start_checkout event sent")

	} catch (e) {
		console.error(e)
	}
})

// view order received page event
// https://www.outbrain.com/help/advertisers/dynamic-values/
jQuery(document).on("pmw:pixel:purchase", (event, payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "outbrain")) return
		if(pmw.canNotFireOutbrainEvent()) return

		const outbrainData = payload.pixels?.outbrain;
		if (!outbrainData) return;

		obApi("track", outbrainData.event_name, outbrainData.event_data)
		pmw.console.log("Outbrain: purchase event sent", outbrainData.event_data)

	} catch (e) {
		console.error(e)
	}
})
